module.exports = __webpack_public_path__ + "upload-image.svg?9d7d579e4df007fee2de2b56525a578e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/upload-image.svg
// module id = 188
// module chunks = 0